import projectService from '@/helpers/api/project.service'

export default {
    namespaced: true,
    state: {
        projectsList: [],
        processing: false,
    },
    actions: {
        getProjects({ commit }) {
            commit('setProcessing', true)
            return projectService.getProjects().then(response => {
                // Api.sendRequest returns obj.data on success
                if (response) {
                    const list = response.list || response.items || (Array.isArray(response) ? response : [])
                    commit('setProjectsList', list)
                }
                return response
            }).finally(() => {
                commit('setProcessing', false)
            })
        },
        createProject({ commit }, data) {
            commit('setProcessing', true)
            return projectService.createProject(data).then(response => {
                return response
            }).finally(() => {
                commit('setProcessing', false)
            })
        },
        updateProject({ commit }, data) {
            commit('setProcessing', true)
            return projectService.updateProject(data).then(response => {
                return response
            }).finally(() => {
                commit('setProcessing', false)
            })
        },
        deleteProject({ commit }, code) {
            commit('setProcessing', true)
            return projectService.deleteProject(code).then(response => {
                return response
            }).finally(() => {
                commit('setProcessing', false)
            })
        },
        assignBot({ commit }, payload) {
            commit('setProcessing', true)
            return projectService.assignBot(payload.bot_key, payload.project_code).then(response => {
                return response
            }).finally(() => {
                commit('setProcessing', false)
            })
        }
    },
    getters: {
        getProjectsList(state) {
            return state.projectsList
        },
        getProcessing(state) {
            return state.processing
        }
    },
    mutations: {
        setProjectsList(state, val) {
            state.projectsList = val
        },
        setProcessing(state, status) {
            state.processing = status
        }
    }
}
